var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMizuhoLogo02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 71.24 19.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#08287f;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12946.46,
    y1: 5021.29,
    x2: 13421.38,
    y2: 5021.29,
    gradientTransform: "translate(-1941.77 -736.05) scale(0.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fad0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ef5b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e6002d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6002d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.44,
    width: 62.36,
    height: 11.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 71.24,
    height: 19.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.1,19.91a204.59,204.59,0,0,0-71,0A.11.11,0,0,1,0,19.83a.11.11,0,0,1,.08-.15,121.78,121.78,0,0,1,71.07,0,.11.11,0,0,1,.07.15A.11.11,0,0,1,71.1,19.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.4,0c-.56,1.41-1.14,2.83-1.76,4.25l-.82,1.89L11,4.25Q10,2.12,9.19,0H4.57V.37a.94.94,0,0,1,.94,1c-.07,1-.16,2-.26,2.93l-.3,3c-.14,1.43-.31,2.85-.51,4.25H5.91c.09-1.4.21-2.82.35-4.25l.46-4.48q1,2,1.89,4.11l.17.37c.63,1.43,1.22,2.85,1.8,4.25H11c.56-1.4,1.15-2.82,1.76-4.25l.27-.61c.59-1.37,1.21-2.74,1.85-4.1l.48,4.71c.14,1.43.26,2.85.35,4.25h3.39c-.2-1.4-.37-2.82-.51-4.25l-.3-3C18.16,2.83,18.05,1.41,18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.61,10.33c.37-.7.77-1.41,1.19-2.12l4.12-6.86V1.06H25.86V3.17h.36a.94.94,0,0,1,.88-.95l.84,0h2.92c-.36.69-.75,1.39-1.16,2.08l-4.14,6.91v.28h9.78V10.25c-.69.06-1.39.08-2.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.37,11.47h.09c-.06-.71-.09-1.41-.09-2.12V6.77h4.05V9.35c0,.71,0,1.42-.08,2.12h3.12c-.06-.7-.08-1.41-.08-2.12V3.19c0-.71,0-1.42.08-2.13h-4v.33h.08a.84.84,0,0,1,.83.79c0,.34,0,.67,0,1V5.63H46.37V3.19q0-1.06.09-2.13h-4v.33h.09a.82.82,0,0,1,.82.79c0,.33,0,.67,0,1V10.4a10.1,10.1,0,0,1-1.25.08,7.53,7.53,0,0,1-1.35-.12,1.91,1.91,0,0,1-1.44-2.13V3.13c0-.7,0-1.38.08-2.07h-4v.33h.08a.84.84,0,0,1,.83.79c0,.33,0,.67,0,1V7.73a3.46,3.46,0,0,0,3.1,3.7,19.22,19.22,0,0,0,2.65.19C43.58,11.62,45,11.57,46.37,11.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.8,6.27h0c0,3.55-3.06,5.35-6.08,5.35s-6.09-1.8-6.09-5.35h0c0-3.55,3.06-5.35,6.09-5.35s6.08,1.8,6.08,5.35Zm-3,0c0-1.93-.82-4.21-3.12-4.21S57.6,4.34,57.6,6.27s.81,4.21,3.12,4.21S63.83,8.2,63.84,6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.15,3.19c0-.71,0-1.42.08-2.13H20.15v.37h.09a1,1,0,0,1,.94,1c0,.26,0,.53,0,.8V9.35c0,.71,0,1.42-.08,2.12h3.12c-.06-.7-.08-1.41-.08-2.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMizuhoLogo02);
export default __webpack_public_path__ + "static/media/mizuho_logo02.178d02a1771c5371549abb7580937c7d.svg";
export { ForwardRef as ReactComponent };